export default __webpack_public_path__ + "static/media/upload.349265c4.svg";